import React, { useCallback, useMemo } from "react";
import messages from "./messages.i18n";
import { AccessDevicesSpacesCell } from "./AccessDevicesSpacesCell";
export function AccessDevicesTableConfig({ debouncedSearchKey, community }) {
    const accessDeviceRowTransform = useCallback((row) => {
        var _a, _b, _c, _d, _e;
        const decoratedRow = row;
        if (debouncedSearchKey) {
            const searchKey = debouncedSearchKey.toLowerCase();
            if ((_a = row.identifier) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchKey))
                return decoratedRow;
            if ((_b = row.type) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchKey))
                return decoratedRow;
            if ((_c = row.manufacturer) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(searchKey))
                return decoratedRow;
            if ((_d = row.model) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(searchKey))
                return decoratedRow;
            if ((_e = row.community.name) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(searchKey))
                return decoratedRow;
            return null;
        }
        return decoratedRow;
    }, [debouncedSearchKey]);
    const accessDevicesParams = useMemo(() => {
        return {
            include: "accessDevice",
            linkedToAccessDevice: true,
            community: { _id: community._id },
            projection: "community,unit,floorPlan,accessDevice,building,sgtEnabled,bathrooms,bedrooms&include=accessDevice",
        };
    }, []);
    const accessDevicesColumns = useMemo(() => {
        return [
            // @ts-ignore
            {
                id: "identifier",
                label: messages.deviceId,
                sortable: true,
                accessor: "identifier",
            },
            {
                id: "name",
                label: messages.keyBox,
                sortable: true,
                accessor: "name",
            },
            {
                // TODO Needed to be requested
                id: "isPerimeterAccess",
                label: messages.location,
                sortable: true,
                accessor: "isPerimeterAccess",
            },
            {
                id: "type",
                label: messages.deviceType,
                sortable: true,
                accessor: "type",
            },
            {
                id: "manufacturer",
                label: messages.manufacturer,
                sortable: true,
                accessor: "manufacturer",
            },
            {
                id: "model",
                label: messages.model,
                sortable: true,
                accessor: "model",
            },
            {
                id: "community.name",
                label: messages.property,
                sortable: true,
                accessor: "community.name",
            },
            {
                id: "spaces",
                label: messages.associatedSpaces,
                sortable: true,
                render: (row) => React.createElement(AccessDevicesSpacesCell, { showBuildingName: !!(row === null || row === void 0 ? void 0 : row.spaces), spaces: row.spaces }),
            },
        ];
    }, []);
    return {
        accessDevicesParams,
        accessDevicesColumns,
        accessDeviceRowTransform,
    };
}
